
























































































import { Component, Vue, Watch } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import Datepicker from 'vuejs-datepicker';
import { WalletHistory } from '@/models/wallet-history';
import moment from 'moment'
import Paging from '@/shared/components/Paging.vue';

import creditServices from '@/services/credit-services';
import { DATA } from '../../../config/data';

@Component({
    components: {
        Datepicker,
        Paging,
        Loading
    }
})
export default class WalletHistories extends Vue {
    private pageSettings = {
      rowPerPage: 10,
      pageSize: 6,
      pageIndex: 1,
      total: 0,
    };

    private listWalletlHistories: WalletHistory[] = [];
    private isCreated = false;
    private isLoading = false;
    private startDate = moment(Date.now()).subtract(1, 'months').startOf('month').toDate();
    private endDate = moment(Date.now()).endOf('month').toDate();
    private selectedType = 0;
    private summary = null;

    @Watch('startDate', { immediate: true, deep: true })
    private async watchStartDate() {
        if (this.startDate && this.isCreated) {
            await this.loadData();
        }
    }

    @Watch('endDate', { immediate: true, deep: true })
    private async watchEndDate() {
        if (this.endDate && this.isCreated) {
            await this.loadData();
        }
    }

    @Watch('selectedType', { immediate: true, deep: true })
    private async watchSelectedType() {
        if (this.isCreated) {
            await this.loadData();
        }
    }

    get tradeTypes() {
        let types = [{value: 0, name: 'Tất cả'}];
        types = types.concat(DATA.walletTradeType);
        return types;
    }

    private async created() {
        await this.loadData();
        this.isCreated = true;
    }

    private async loadData() {
        this.isLoading = true;
        this.pageSettings.total = 0;
        this.listWalletlHistories = [];
        const result = await creditServices.walletHistories(this.pageSettings.pageIndex, this.pageSettings.rowPerPage, moment(this.startDate).format('YYYY-MM-DD HH:mm:ss'),  moment(this.endDate).format('YYYY-MM-DD HH:mm:ss'), this.selectedType);
        if (result && result.status === 200 && result.data.status === 200) {
            this.pageSettings.total = result.data.total;
            for (const item of result.data.data) {
                const hist = new WalletHistory();
                hist.id = item.ID;
                hist.uId = item.UID;
                hist.userName = item.UserName;
                hist.mainOrderId = item.MainOrderID;
                hist.amount = item.Amount;
                hist.hContent = item.HContent;
                hist.moneyLeft = item.MoneyLeft;
                hist.type = item.Type;
                hist.tradeType = item.TradeType;
                hist.tradeTypeDetail = DATA.walletTradeType.find(x => x.value === item.TradeType) || { value: 0, name: 'Khác' },
                hist.createDate = item.CreatedDate;
                hist.createBy = item.CreatedBy;
                hist.userRecharge = item.UserRecharge;
                hist.rechargeId = item.RechrgeID;
                hist.orderType = item.OrderType;

                this.listWalletlHistories.push(hist);
            }
            this.summary = result.data.summary;
        }

        this.isLoading = false;
    }

    private onChangePage(data: any) {
      this.pageSettings.pageIndex = data;
      this.loadData();
    }
}
